/**
 * Worker profile card - reference design: large profile area at top, rank badge,
 * name, star rating + reviews, revenue.
 */
import { useTranslation } from 'react-i18next';
import { resolveMediaUrl } from '../../utils/api';

const AVATAR_COLORS = ['#0ea5e9', '#3b82f6', '#6366f1', '#8b5cf6'];

export default function WorkerProfileCard({ worker, rank = 1 }) {
  const { t } = useTranslation();
  const name = worker?.artist_name || '—';
  const rating = worker?.rating != null ? Number(worker.rating).toFixed(1) : '0';
  const reviewCount = worker?.count ?? 0;
  const revenue = worker?.revenue != null ? Number(worker.revenue).toFixed(2) : '0.00';
  const photoUrl = worker?.photo_url;

  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #e2e8f0',
        minWidth: 180,
        flex: '1 1 180px',
      }}
    >
      <div
        style={{
          position: 'relative',
          height: 100,
          background: AVATAR_COLORS[(rank - 1) % AVATAR_COLORS.length],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {photoUrl ? (
          <img
            src={resolveMediaUrl(photoUrl)}
            alt=""
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <span
            style={{
              fontSize: '2.5rem',
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
              textShadow: '0 1px 2px rgba(0,0,0,0.2)',
            }}
          >
            {name[0]?.toUpperCase() || '?'}
          </span>
        )}
        <span
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            background: '#374151',
            color: '#fff',
            fontSize: '0.75rem',
            fontWeight: 700,
            padding: '0.2rem 0.5rem',
            borderRadius: 6,
          }}
        >
          #{rank}
        </span>
      </div>
      <div style={{ padding: '1rem' }}>
        <div
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: '1rem',
            color: '#1e293b',
            marginBottom: '0.35rem',
          }}
        >
          {name}
        </div>
        <div
          style={{
            fontSize: '0.85rem',
            color: '#1e293b',
            marginBottom: '0.5rem',
          }}
        >
          <span style={{ color: '#d97706' }}>★</span> {rating}{' '}
          <span style={{ color: '#64748b', fontWeight: 400 }}>
            ({reviewCount}+ {t('dashboard.reviews') || 'Reviews'})
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '0.85rem',
          }}
        >
          <span style={{ color: '#64748b' }}>{t('admin.revenue') || 'Revenue'}</span>
          <span style={{ fontWeight: 700, color: '#1e293b' }}>EGP {revenue}</span>
        </div>
      </div>
    </div>
  );
}
